import {Banner} from '@primer/react'

type Props = {
  propertyName: string
}

export function DefinitionUsagesBanner({propertyName}: Props) {
  return (
    <Banner
      title="Other definition usages"
      hideTitle
      variant="warning"
      data-testid="usages-banner"
      description={
        <span>
          The <strong>{propertyName}</strong> property may be in use by other GitHub features. Please verify before
          deletion.
        </span>
      }
    />
  )
}
